<section fxLayout.gt-xs="row" fxLayoutGap="0px" fxLayoutGap.gt-xs="20px">
	<div fxFlex.gt-md="50%">
		<div fxLayout="column" class="upload-material-content" fxLayoutGap="20px">
			<div fxFlex="auto" fxFlexAlign="start start">
				<h3 i18n="@@UploadMaterialInstructionsTitle">Upload print-ready material</h3>
				<p i18n="@@UploadMaterialInstructionsDescription"
					>Upload print-ready material here. To print what you need, we need print material made
					according to our guidelines.</p
				>
				@if (instructionsLink; as link) {
					<p>
						<a rel="noopener" target="_blank" [attr.href]="link" i18n="@@MaterialInstructionsLink"
							>View Material Instructions</a
						>
					</p>
				}

				@switch (notification) {
					@case (notificationType.Danger) {
						<section>
							<div class="heading notification-danger">
								@if (isFiletypeError) {
									<span i18n="@@ErrorFileNotPdf">File is not a pdf!</span>
								} @else if (!isFiletypeError && hasCartItem) {
									<span i18n="@@ErrorPrintfileMissing">Please upload a printfile</span>
								}
							</div>
						</section>
					}
					@case (notificationType.Success) {
						<section>
							<div class="heading notification-success">
								<span i18n="@@FileUploadSuccess">File uploaded successfully!</span>
							</div>
						</section>
					}
				}
				@if (item) {
					<g-printfile-report [item]="item" [readOnly]="true" />
				}
			</div>

			@if (product) {
				<div fxFlex="none" fxFlexAlign="end start">
					<g-product-additional-info [product]="product" />
				</div>
			}
		</div>
	</div>

	<aside fxFlex.gt-md="50%">
		<g-upload
			[uploadedFiles]="currentFileItem"
			[options]="uploadOptions$ | async"
			fileType="PRINTFILE"
			acceptedFiletypes="application/pdf"
			(onUploadComplete)="onUploadSuccess($event)"
			(onUploadStart)="onUploadStart($event)"
			(onClear)="resetUploadSettings()"
			(onFiletypeError)="onFiletypeError()"
		/>
	</aside>
</section>
